<template>
    <div>
        <v-card class="pa-4">
            <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  :placeholder="$t('geneticsAndBreeding.searchByAnimalIdName')"
                  dense
                  v-model="search"
                  class="shrink"
                  @input="resetSearchOnEmpty"
                ></v-text-field>
                <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchEPD"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalRecords }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <!-- <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="$router.push({name: 'GeneticsList'})"
                >
                  <v-icon dark> mdi-view-grid-outline </v-icon>
                </v-btn> -->
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  @click="$router.push({name: 'GeneticsList'})"
                >
                  <v-icon dark> mdi-format-list-bulleted </v-icon>
                </v-btn>
            </div>
            <v-row class="mt-5">
                <v-col lg="3" md="4" v-for="x in items" :key="x.animalNumber +  Math.random()">
                    <v-card  class="elevation-0" style="border: 1px solid #00BD7380; border-top: 5px solid #00BD7380;">
                        <v-list
                            two-line
                        >
                            <v-list-item>
                                <v-list-item-avatar size="50">
                                    <v-img  :src="animalImage(x)"></v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                    <v-list-item-subtitle :title="x.name" class="font-weight-bold" >{{x.name || 'N/A'}}</v-list-item-subtitle>

                                    <v-list-item-subtitle :title="x.animalNumber" class="body-2">Animal ID:<a @click.prevent="$router.push({name: 'SingleAnimalEpd', params: {geneticid: x.animal_id}})">{{x.animalNumber}}</a></v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action class="px-0">
                                    <v-btn class="mt-n10" color="green2" fab x-small depressed @click="$router.push({name: 'EditGeneticsV2', params: {geneticid: x.animal_id  }})">
                                        <v-icon color="primary">mdi-pencil</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <v-row class="pr-5"> 
                            <v-col cols="6" class="text-center">
                                <v-chip
                                    small
                                    class="ma-2"
                                    color="green2"
                                    label
                                    text-color="primary"
                                >
                                    Tag # {{ x.tagNumber }}
                                </v-chip>
                            </v-col>
                            <v-col cols="6" class="text-center">
                                <v-chip
                                    small
                                    class="ma-2"
                                    color="green2"
                                    label
                                    text-color="primary"
                                >
                                Gender : {{ x.gender }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="6" class="text-center pa-2">
                                <v-card flat  style="border: 1px solid #BBBBBB">
                                    <v-card-text class="px-0">
                                        <v-list
                                            two-line
                                        >
                                            <v-list-item>
                                                <v-list-item-content class="px-0">
                                                    <v-list-item-subtitle >Birth Date</v-list-item-subtitle>
                                                    <v-list-item-title class="body-2 font-weight-bold" >{{ formatDate(x.birthDate, 'DD/MM/YYYY') || 'N/A' }}</v-list-item-title>

                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="6" class="text-center pa-2">
                                <v-card flat  style="border: 1px solid #BBBBBB">
                                    <v-card-text class="px-0">
                                        <v-list
                                            two-line
                                        >
                                            <v-list-item>
                                                <v-list-item-content class="px-0">
                                                    <v-list-item-subtitle class="text-caption">Birth  Weight</v-list-item-subtitle>
                                                    <v-list-item-title class="body-2 font-weight-bold" >
                                                        {{ (!x.birthWeight || Number.isInteger(x.birthWeight)) ? x.birthWeight : (x.birthWeight).toFixed(2) }}
                                                        {{ weightUnit }}
                                                    </v-list-item-title>

                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="6" class="text-center pa-2">
                                <v-card flat  style="border: 1px solid #BBBBBB">
                                    <v-card-text class="px-0">
                                        <v-list
                                            two-line
                                        >
                                            <v-list-item class="px-0">
                                                <v-list-item-content >
                                                    <v-list-item-subtitle class="text-caption">Weaning  Weight</v-list-item-subtitle>
                                                    <v-list-item-title class="body-2 font-weight-bold" >
                                                        {{ (!x.weaningWeight || Number.isInteger(x.weaningWeight)) ? x.weaningWeight : (x.weaningWeight).toFixed(2) }}
                                                        {{ weightUnit }}
                                                    </v-list-item-title>

                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="6" class="text-center pa-2">
                                <v-card flat  style="border: 1px solid #BBBBBB">
                                    <v-card-text class="px-0">
                                        <v-list
                                            two-line
                                        >
                                            <v-list-item>
                                                <v-list-item-content class="px-0">
                                                    <v-list-item-subtitle class="text-caption">Yearling  Weight</v-list-item-subtitle>
                                                    <v-list-item-title class="body-2 font-weight-bold" >
                                                        {{ (!x.yearlingWeight || Number.isInteger(x.yearlingWeight)) ? x.yearlingWeight : (x.yearlingWeight).toFixed(2) }}
                                                        {{ weightUnit }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import gql from "graphql-tag";

export default {
  apollo: {
    epdData: {
      query: gql`
        query searchEdp($searchEdpInput: SearchEdpInput!) {
            searchEdp(searchEdpInput: $searchEdpInput) {
              rows{
                id
                animal_id
                birth_weight_epd
                weaning_weight_epd
                yearling_weight_epd
                birth_weight_kg
                weaning_weight_kg
                yearling_weight_kg
                birthDate
                gender
                name
                animalNumber
              }
              count
              returnedRecords
              weightUnit    
          }
        }
      `,
      variables() {
        return {
          searchEdpInput:this.filter
        };
      },
      result: function ({ data }) {
        if (data) {
          //array1.shift();
          this.items = data.searchEdp.rows;
          this.weightUnitt = data.searchEdp.weightUnit;
          this.totalRecords = data.searchEdp.count;
          this.totalPages = Math.ceil(
              this.totalRecords / this.tableOptions.itemsPerPage
          );

          this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
          this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - data.searchEdp.returnedRecords);

            // this.all = data.countEpd.all;
            // this.grouped = data.countEpd.grouped;
            // this.ungrouped = data.countEpd.ungroupped;
        }
      },
      update: (data) => {
        return data.searchEdp;
      },
      error: (err) =>
        this.$notify({
          title: "Error loading animal diseases!",
          text: err,
          type: "error",
          position: "top right",
        }),
    },
  },
    mounted() {
        if(this.$route.query.page){
            this.tableOptions.page = this.$route.query.page
        }
        this.getEPDData();
    },
    computed: {
      weightUnit() {
        return (this.weightUnitt || 'lbs').toLowerCase()
      }
    },
    data() {
        return {
          filter:{
            page:1,
            limit:10,
            searchPhrase:"",
            //userId:6
            userId:this.$store.getters.getUser.id,
          },
            weightUnitt: 'lbs',
            loading: false,
            search: "",
            selected: [],
            totalRecords: 0,
            totalPages: 0,
            to: 0,
            from: 0,
            tableOptions: {
                page: 1,
                itemsPerPage: 12,
                sortBy: [],
                sortDesc: []
            },
            items: [],
        }
    },
    methods: {
      getEPDData() {
        const { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
        const filter = {
          page:parseInt(page),
          limit:itemsPerPage,
          searchPhrase:this.search,
          userId:this.$store.getters.getUser.id,
          //userId:6
        }
   
        if (sortBy.length === 1 && sortDesc.length === 1){
          filter.sortCol = sortBy[0];
          filter.sortOrder = sortDesc[0]? 'DESC' : 'ASC'
        }

        this.filter = filter;
        this.$apollo.queries.epdData.refetch();
      },
      searchEPD() {
        if (this.search == "") return;
        this.tableOptions.page = 1;
        this.getEPDData();
      },

      resetSearchOnEmpty() {
        if (this.search !== "") return;
        this.tableOptions.page = 1;
        this.getEPDData();
      },
      pageChange(t) {
        if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
        else this.tableOptions.page = Number(this.tableOptions.page) - 1;
            this.$router.replace(
              {query: { page: this.tableOptions.page}}
            )
            this.getEPDData();
        },
        animalImage(x) {
            return x?.img?.url || '/img/no_img.png'
        }
    },
    mixins: [loadingMixin, generalMixin]
}
</script>